import { createAsyncThunk } from '@reduxjs/toolkit';

import { ITransactionLog } from '.';
import {
  AdminApiPaths,
  APIDataProvider,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';

export type TAdminGetTransactionLogs = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  userId?: string;
  startDate?: string;
  endDate?: string;
};

export type TAdminTransactionLogCreateAdminNote = {
  id: string;
  description: string;
};

export type TAdminTransactionLogDeleteAdminNote = {
  id: string;
  noteId: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetTransactionLogsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  userId,
  startDate,
  endDate,
}: TAdminGetTransactionLogs) => {
  let path = `${AdminApiPaths.transactionLogs}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (userId) {
    path += `&userId=${userId}`;
  }

  if (startDate) {
    path += `&startDate=${startDate}`;
  }

  if (endDate) {
    path += `&endDate=${endDate}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<ITransactionLog>>
  >(path);

  return response.data;
};

export const adminGetTransactionLogs = createAsyncThunk(
  '/admin/transaction-logs/list',
  adminGetTransactionLogsModule
);

export const adminCreateTransactionLogAdminNote = createAsyncThunk(
  '/admin/transaction-logs/admin-notes/create',
  async (data: TAdminTransactionLogCreateAdminNote) => {
    const response = await apiDataProvider.post<TApiResponse<ITransactionLog>>(
      `${AdminApiPaths.transactionLogs}/admin-notes/${data.id}`,
      data
    );

    return response.data;
  }
);

export const adminDeleteTransactionLogAdminNote = createAsyncThunk(
  '/admin/transaction-logs/admin-notes/delete',
  async ({ id, noteId }: TAdminTransactionLogDeleteAdminNote) => {
    const response = await apiDataProvider.delete<
      TApiResponse<ITransactionLog>
    >(
      `${AdminApiPaths.transactionLogs}/admin-notes/${id}?id=${id}&noteId=${noteId}`
    );

    return response.data;
  }
);
